import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '@core/services/auth/auth.service';
import { HttpService } from '@core/services/http/http.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LocalStorageService } from '@core/services/localStorage/local-storage.service';
import { HttpRefreshTokenInterceptor } from '@app/core/services/interceptors/http-refresh-token.interceptor.service';


const providers = [
  AuthService,
  HttpService,
  LocalStorageService,
  HttpClientModule
];

@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [providers, {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpRefreshTokenInterceptor,
    multi: true
  },
  ],
  exports: [],
  declarations: []
})
export class CoreModule { }
